import Enumerator from '../global/Enumerator';

export const propertyDetailsTypes = ['none', 'rp_data', 'pricefinder'];

export class PropertyDetailsType extends Enumerator {
  static default() {
    return this.of('none');
  }
}

PropertyDetailsType.initEnum({
  none: {
    get title() {
      return 'None';
    }
  },
  rp_data: {
    get title() {
      return 'RP Data';
    }
  },
  pricefinder: {
    get title() {
      return 'Pricefinder';
    }
  }
});

export default {
  propertyDetailsTypes,
  PropertyDetailsType
};
